import { useEffect, useState } from 'react';
import { getStoredAttribution, SignupAttribution } from '@/lib/promoAttribution';

export const usePromoAttribution = () => {
  const [data, setData] = useState<SignupAttribution | null>(() => getStoredAttribution());

  useEffect(() => {
    setData(getStoredAttribution());
  }, []);

  return data;
};
